import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  makeStyles,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Typography,
} from "@material-ui/core";
import Header from "../components/Header";
import PatientStatus from "../components/PatientStatus";
import { apiAxios, cndURL } from "../Util/ApiAxios";
import { BiXCircle } from "react-icons/bi";
import { Pagination } from "@material-ui/lab";
import { toast } from "react-toastify";
import CheckIcon from "@material-ui/icons/Check";
import CheckCircleOutlinedIcon from "@material-ui/icons/CheckCircleOutlined";
import HighlightOffOutlinedIcon from "@material-ui/icons/HighlightOffOutlined";
import Loader from "react-loader-spinner";

const RequestedAppointment = () => {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [requestList, setRequestList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const currentPageRef = useRef(1);
  const [message, setMessage] = useState("");
  const [isReasonModal, setReaonModal] = useState(false);
  const [reasonList, setReasonList] = useState([]);
  const [isActionModalOpen, setActionModalOpen] = useState(false);
  const [actionSlected, setActionSlected] = useState("");
  const [StatusError, setStatusError] = useState("");
  const [requestID, setRequestID] = useState("");
  const [isSuccessModalOpen, setSuccessModalOpen] = useState(false);
  const [SuccessMessage, setSuccessMessage] = useState("");
  const [appointmentWith, setAppointmentWith] = useState("");
  const [rescheduleModal, setRescheduleModal] = useState(false);
  const [timeSlots, setTimeSlots] = useState([]);
  const [selectedTime, setSelectedTime] = useState("");
  const [selectedEndTime, setSelectedEndTime] = useState("");
  const [selectedMemberID, setSelectedMemberID] = useState("");
  const [selectedDate, setSelectedDate] = useState(
    () => new Date().toISOString().split("T")[0]
  );
  const [showLoader, setShowLoader] = React.useState(false);
  const [slotsError, setSlotsError] = useState("");
  const [scheduleId, setScheduleId] = useState("");

  const getSlots = async (date, id) => {
    setSlotsError("");
    try {
      const slotResp = await fetch(cndURL("/cnd/public/calendar-slots"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          appointment_date: date,
          appointment_type: "2",
          doctor_id: id,
          visit_type: "1",
        }),
      });
      const slotRespJSON = await slotResp.json();
      if (slotRespJSON?.status?.toString().startsWith("2")) {
        const now = new Date();
        const filteredSlots = slotRespJSON?.slot_data?.filter(
          (slot) => new Date(slot.appointment_start_time) > now
        );
        if (filteredSlots.length === 0) {
          setSlotsError("Slots does not exist.");
        } else {
          setTimeSlots(filteredSlots);
        }
      } else {
        setSlotsError("Slots does not exist.");
        setTimeSlots([]);
      }
    } catch (err) {
      console.error(err);
      setSlotsError("Slots does not exist.");
      setTimeSlots([]);
    }
  };

  const getRequestList = useCallback(
    async ({
      table_config_rows_per_page = "20",
      table_config_page_no = "1",
    } = {}) => {
      setCurrentPage(parseInt(table_config_page_no));

      setRequestList([]);
      setMessage("Loading...");

      const userData = {
        table_config_rows_per_page: table_config_rows_per_page,
        table_config_page_no: table_config_page_no,
        status_filter: [8],
      };

      apiAxios
        .post("/user/request-list", userData, {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("dhct_Token"),
          },
        })
        .then((response) => {
          console.log("response --> ", response);
          if (response.data.statusCode == 200) {
            setRequestList(response.data.body);
            setMessage("");
            const total_Pages = Math.ceil(
              response.data.total_rows_count / response.data.rows_per_page
            );
            setTotalPages(total_Pages);
          } else if (response.data.statusCode == 502) {
            setMessage("No Data Found");
          } else {
            setMessage(response.data.message);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    []
  );

  useEffect(() => {
    getRequestList({ table_config_page_no: currentPageRef.current.toString() });
  }, [getRequestList]);
  const openReasonModal = (selected) => {
    setReasonList(selected);
    setReaonModal(true);
  };
  const closeReasonModal = (e) => {
    e?.stopPropagation();
    setReaonModal(false);
  };
  const openActionModal = (selected) => {
    setRequestID(selected.request_id);
    setActionModalOpen(true);
  };
  const closeActionModal = (e) => {
    e?.stopPropagation();
    setActionModalOpen(false);
    setActionSlected("");
  };

  const appointmentOptions =
    appointmentWith === "Other"
      ? [{ value: "OTHER", label: "Acknowledge" }]
      : [
          { value: "APPROVED", label: "Approved" },
          { value: "RESCHEDULED", label: "Re-scheduled" },
          { value: "DENY", label: "Rejected" },
        ];

  const scheduleAppointment = () => {
    if (actionSlected !== "RESCHEDULED") {
      const userData = {
        appointment_action: actionSlected,
        request_id: requestID,
      };
      setShowLoader(true);
      apiAxios
        .post("user/requested/appointment-schedule", userData, {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("dhct_Token"),
          },
        })
        .then((response) => {
          console.log("response --> ", response);
          if (response.data.statusCode == 200) {
            setActionModalOpen(false);
            setSuccessModalOpen(true);
            setSuccessMessage(response.data.message);
          } else {
            toast.error(response.data.message, {
              position: "bottom-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
            setActionModalOpen(false);
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          setShowLoader(false);
          setActionSlected("");
        });
    } else {
      if (selectedTime) {
        setShowLoader(true);
        const userData = {
          appointment_action: actionSlected,
          calendar_schedule_id: scheduleId ? scheduleId : "",
          request_id: requestID,
          appointment_date: selectedDate,
          start_time:
            new Date(selectedTime + " UTC")
              .toISOString()
              .split("T")[1]
              .slice(0, 8) + "+00:00",
          end_time:
            new Date(selectedEndTime + " UTC")
              .toISOString()
              .split("T")[1]
              .slice(0, 8) + "+00:00",
          start_time_slot: selectedTime,
          end_time_slot: selectedEndTime,
          appointment_start_time: new Date(selectedTime)
            .toTimeString()
            .split(" ")[0],
          appointment_end_time: new Date(selectedEndTime)
            .toTimeString()
            .split(" ")[0],
        };
        apiAxios
          .post("user/requested/appointment-schedule", userData, {
            headers: {
              "Content-Type": "application/json",
              Authorization: localStorage.getItem("dhct_Token"),
            },
          })
          .then((response) => {
            if (response.data.statusCode == 200) {
              setActionModalOpen(false);
              setRescheduleModal(false);
              setSuccessModalOpen(true);
              setSuccessMessage(response.data.message);
              setActionSlected("");
            } else {
              toast.error(response.data.message, {
                position: "bottom-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              });
              console(response.data.message);
            }
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => {
            setShowLoader(false);
          });
      }
    }
  };
  useEffect(() => {
    getSlots(selectedDate, selectedMemberID);
  }, [selectedDate, selectedMemberID]);
  const select = () => {
    if (actionSlected !== "RESCHEDULED") {
      scheduleAppointment();
    } else {
      setRescheduleModal(true);
      getSlots(selectedDate, selectedMemberID);
    }
  };

  const dates = Array.from({ length: 10 }, (_, i) => {
    const today = new Date();
    today.setDate(today.getDate() + i);
    return today.toISOString().split("T")[0];
  });

  return (
    <div>
      <Header />
      <Box className={classes.pagecontent}>
        <Box className={classes.leftcol}>
          <Box className={classes.leftnav} style={{ marginTop: "40px" }}>
            {localStorage.getItem("dhct_JWT") ? <PatientStatus /> : <></>}
          </Box>
        </Box>
        <Box className={classes.Rightcol}>
          <Box>
            <h3 className={classes.topheading}>Requested Appointments</h3>
          </Box>
          <Box className={classes.PatientListTable}>
            <Box className={classes.throw}>
              <Box className={classes.program}>Appointment with</Box>
              <Box className={classes.provider}>Patient Name</Box>
              <Box className={classes.date}>Date</Box>
              <Box className={classes.time}>Slot Time</Box>
              <Box className={classes.hrpmID}>HRPM ID</Box>
              <Box className={classes.reason}>Reson</Box>
              <Box className={classes.phone}>Current Status</Box>
              <Box className={classes.action}>Action</Box>
            </Box>
            {requestList.length > 0 ? (
              <>
                {requestList.map((each) => (
                  <Box key={each.appointment_number} className={classes.tdrow}>
                    <Box className={classes.program}>{each.doctor_name}</Box>
                    <Box className={classes.provider}>{each.patient_name}</Box>
                    <Box className={classes.date}>{each.appointment_date}</Box>
                    <Box className={classes.time}>
                      {`${
                        each.start_time
                          ? each.start_time.split(":").slice(0, 2).join(":")
                          : ""
                      }-${
                        each.end_time
                          ? each.end_time.split(":").slice(0, 2).join(":")
                          : ""
                      }`}
                    </Box>
                    <Box className={classes.hrpmID}>{each.hrpm_id}</Box>
                    <Box
                      className={classes.reason}
                      onClick={() => openReasonModal(each)}
                    >
                      <b style={{ color: "#88b3eb" }}>View</b>
                    </Box>
                    <Box className={classes.phone}>
                      {each.current_status === 9
                        ? "Approved"
                        : each.current_status === 10
                        ? "Rescheduled"
                        : each.current_status === 11
                        ? "Rejected"
                        : each.current_status === 12
                        ? "Acknowledged"
                        : "Request Raised"}
                    </Box>
                    <Box
                      className={classes.action}
                      onClick={() => {
                        openActionModal(each);
                        setAppointmentWith(each.doctor_name);
                        setSelectedMemberID(each.doctor_id);
                      }}
                    >
                      <b style={{ color: "#88b3eb" }}>Change Status</b>
                    </Box>
                  </Box>
                ))}
              </>
            ) : (
              <Box style={{ marginTop: "30px", textAlign: "center" }}>
                {message ? message : "No Appointments Found"}
              </Box>
            )}
          </Box>
          {/* Reason Modal */}
          <Dialog
            onClose={closeReasonModal}
            aria-labelledby="customized-dialog-title"
            open={isReasonModal}
          >
            <DialogContent className={classes.ccmmodal}>
              <Typography
                variant="h3"
                style={{
                  fontSize: 18,
                  fontFamily: "poppins",
                  fontWeight: "600",
                  marginRight: "60px",
                }}
              >
                Reason for Appointment
              </Typography>
              <Box className={classes.btncol}>
                <Button
                  onClick={closeReasonModal}
                  className={classes.Modalclose}
                >
                  <BiXCircle className={classes.closeicon} />
                </Button>
              </Box>
              <DialogContentText id="alert-dialog-slide-description">
                {reasonList ? (
                  <Typography
                    style={{
                      fontSize: 16,
                      fontFamily: "poppins",
                      marginTop: "10px",
                    }}
                  >
                    {reasonList.reason}
                  </Typography>
                ) : null}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                size="large"
                className={classes.Deletebtn}
                onClick={closeReasonModal}
              >
                Close
              </Button>
            </DialogActions>
          </Dialog>
          {/* Action Modal */}
          <Dialog
            className={classes.modal}
            onClose={closeActionModal}
            aria-labelledby="customized-dialog-title"
            open={isActionModalOpen}
          >
            <DialogContent>
              <Typography
                variant="h3"
                style={{
                  fontSize: 18,
                  fontFamily: "Poppins",
                  fontWeight: "600",
                  marginRight: "60px",
                }}
              >
                Change the status of appointment
              </Typography>
              <Box>
                <Button
                  onClick={closeActionModal}
                  className={classes.Modalclose}
                >
                  <BiXCircle
                    size="30"
                    color="#0f3d6e"
                    className={classes.closeicon}
                  />
                </Button>
              </Box>
              <DialogContentText>
                <Box>
                  <FormControl
                    fullWidth
                    error={!!StatusError}
                    style={{ marginTop: "16px" }}
                  >
                    <Typography variant="subtitle1">
                      Change Status<span style={{ color: "#ff0000" }}>*</span>
                    </Typography>
                    <Select
                      value={actionSlected}
                      onChange={(event) => {
                        setActionSlected(event.target.value);
                        setStatusError("");
                      }}
                      displayEmpty
                      MenuProps={{
                        PaperProps: {
                          style: {
                            marginTop: 80,
                          },
                        },
                      }}
                    >
                      <MenuItem value="" disabled>
                        Select a status
                      </MenuItem>
                      {appointmentOptions.map((opt) => (
                        <MenuItem key={opt.value} value={opt.value}>
                          {opt.label}
                        </MenuItem>
                      ))}
                    </Select>
                    {StatusError ? (
                      <p
                        style={{
                          color: "#dc3545",
                          fontSize: ".875em",
                          marginTop: "0.25rem",
                          width: "100%",
                          textAlign: "right",
                        }}
                      >
                        Please select status.
                      </p>
                    ) : (
                      <></>
                    )}
                  </FormControl>
                </Box>
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              {showLoader ? (
                <Loader
                  type="ThreeDots"
                  color="#000000"
                  height={50}
                  width={50}
                  timeout={0}
                  marginRight={20}
                />
              ) : (
                <Button
                  size="large"
                  style={{ color: "#fff" }}
                  className={classes.chartbtn}
                  disabled={!actionSlected}
                  onClick={select}
                >
                  {actionSlected
                    ? actionSlected.charAt(0).toUpperCase() +
                      actionSlected.slice(1).toLowerCase()
                    : "Action"}
                </Button>
              )}
            </DialogActions>
          </Dialog>
          {/* Success Modal */}
          <Dialog
            onClose={() => setSuccessModalOpen(false)}
            aria-labelledby="customized-dialog-title"
            open={isSuccessModalOpen}
          >
            <DialogContent className={classes.ccmmodal}>
              <Box>
                <Button
                  onClick={() => setSuccessModalOpen(false)}
                  className={classes.Modalclose}
                >
                  <BiXCircle
                    className={classes.closeicon}
                    size="30"
                    color="#0f3d6e"
                  />
                </Button>
              </Box>
              <DialogContentText id="alert-dialog-slide-description">
                {actionSlected === "DENY" ? (
                  <HighlightOffOutlinedIcon
                    style={{
                      color: "red",
                      width: "80px",
                      height: "80px",
                      alignSelf: "center",
                    }}
                  />
                ) : (
                  <CheckCircleOutlinedIcon
                    style={{
                      color: "green",
                      width: "80px",
                      height: "80px",
                      alignSelf: "center",
                    }}
                  />
                )}

                <Typography style={{ marginTop: "10px" }}>
                  {SuccessMessage}
                </Typography>
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                size="large"
                className={classes.Deletebtn}
                onClick={() => {
                  setSuccessModalOpen(false);
                  window.location.href = "/action-takenlist";
                }}
              >
                OK
              </Button>
            </DialogActions>
          </Dialog>
          {/* Re-schedule Modal */}
          <Dialog
            onClose={() => {
              setRescheduleModal(false);
              setActionModalOpen(false);
            }}
            aria-labelledby="customized-dialog-title"
            open={rescheduleModal}
          >
            <DialogContent className={classes.ccmmodal}>
              <Box>
                <Button
                  onClick={() => {
                    setRescheduleModal(false);
                    setActionModalOpen(false);
                  }}
                  className={classes.Modalclose}
                >
                  <BiXCircle
                    className={classes.closeicon}
                    size="30"
                    color="#0f3d6e"
                  />
                </Button>
              </Box>
              <Box
                sx={{
                  maxHeight: "60vh",
                  overflowY: "auto",
                  paddingRight: "10px",
                  paddingLeft: "10px",
                  overflowX: "hidden",
                  scrollbarWidth: "none",
                  "&::-webkit-scrollbar": {
                    display: "none",
                  },
                }}
              >
                <DialogContentText id="alert-dialog-slide-description">
                  <Typography style={{ marginTop: "50px" }}>
                    pick a re-schedule date :
                    <RadioGroup
                      value={selectedDate}
                      onChange={(e) => setSelectedDate(e.target.value)}
                      className={classes.radioGroup}
                      row
                    >
                      {dates.map((day) => (
                        <FormControlLabel
                          key={day}
                          value={day}
                          control={
                            <Radio
                              color="default"
                              style={{ display: "none" }}
                            />
                          }
                          label={
                            <div
                              className={`${classes.radioOption} ${
                                selectedDate === day ? "checked" : ""
                              }`}
                            >
                              {new Date(day).toLocaleDateString(undefined, {
                                weekday: "long",
                              })}
                              <br />
                              {new Date(day).toLocaleDateString(undefined, {
                                month: "short",
                                day: "2-digit",
                              })}
                            </div>
                          }
                        />
                      ))}
                    </RadioGroup>
                  </Typography>
                  <Typography style={{ marginTop: "20px" }}>
                    Select a re-schedule time
                  </Typography>
                  <Typography style={{ marginTop: "20px" }}>
                    {slotsError ? (
                      <Typography
                        style={{ mt: 10, color: "#000", fontWeight: 500 }}
                      >
                        {slotsError}
                      </Typography>
                    ) : (
                      selectedDate !== null && (
                        <Grid container spacing={2} mt={2}>
                          <Grid container spacing={2} mt={2}>
                            {timeSlots.map((slot, index) => (
                              <Grid item xs={6} sm={4} md={3} key={index}>
                                <Button
                                  onClick={() => {
                                    setSelectedTime(
                                      slot.appointment_start_time
                                    );
                                    setSelectedEndTime(
                                      slot.appointment_end_time
                                    );
                                    setScheduleId(slot.id);
                                  }}
                                  variant={
                                    selectedTime === slot.appointment_start_time
                                      ? "contained"
                                      : "outlined"
                                  }
                                  color="primary"
                                  fullWidth
                                  sx={{
                                    py: 2,
                                    textTransform: "none",
                                    borderRadius: 2,
                                    background:
                                      selectedTime ===
                                      slot.appointment_start_time
                                        ? "#114ebd"
                                        : "transparent",
                                    color:
                                      selectedTime ===
                                      slot.appointment_start_time
                                        ? "white"
                                        : "#ffffff",
                                    borderColor:
                                      selectedTime ===
                                      slot.appointment_start_time
                                        ? "transparent"
                                        : "#ffffff",
                                  }}
                                >
                                  {new Date(
                                    slot.appointment_start_time
                                  ).toLocaleTimeString(undefined, {
                                    hour12: true,
                                    hour: "2-digit",
                                    minute: "2-digit",
                                  })}
                                </Button>
                              </Grid>
                            ))}
                          </Grid>
                        </Grid>
                      )
                    )}
                  </Typography>
                </DialogContentText>
              </Box>
            </DialogContent>
            <DialogActions>
              {showLoader ? (
                <Loader
                  type="ThreeDots"
                  color="#000000"
                  height={50}
                  width={50}
                  timeout={0}
                  marginRight={20}
                />
              ) : (
                <Button
                  size="large"
                  className={classes.chartbtn}
                  onClick={selectedTime && scheduleAppointment}
                >
                  Re-schedule
                </Button>
              )}
            </DialogActions>
          </Dialog>
          <div
            style={{
              width: "100%",
              display: "flex",
              alignItems: "right",
              justifyContent: "right",
            }}
          >
            <Pagination
              count={totalPages}
              color="primary"
              page={currentPage}
              onChange={(event, pageNumber) => {
                setCurrentPage(pageNumber);
                getRequestList({
                  table_config_page_no: pageNumber.toString(),
                });
              }}
            />
          </div>
        </Box>
      </Box>
    </div>
  );
};

export default RequestedAppointment;

const useStyles = makeStyles((theme) => ({
  pagecontent: {
    width: "100%",
    overflow: "hidden",
    display: "flex",
    "& a": {
      textDecoration: "none",
    },
  },
  Rightcol: {
    width: "75%",
    padding: "20px 2%",
    borderLeft: "1px #F6F6F6 solid",
    "@media only screen and (max-width: 820px)": {
      width: "96%",
      padding: "0 2%",
      marginTop: 30,
    },
    "@media only screen and (max-width: 768px)": {
      width: "96%",
      padding: "0 2%",
      marginTop: 30,
    },
    "& .MuiAccordionSummary-root": {
      borderBottom: "1px #5f80a9 solid",
      height: "40px",
      color: "#bfc4cb",
      padding: "0px",
      fontFamily: "Poppins",
    },
    "& .MuiAccordion-root:before": {
      display: "none",
    },
    "& .MuiTab-root": {
      minWidth: "33%",
    },
    "& .MuiTab-root:nth-child(6)": {
      minWidth: "30%",
    },
    "& .MuiTab-root:nth-child(7)": {
      minWidth: "30%",
    },
  },

  leftcol: {
    width: "15%",
    padding: "20px 3%",
    minHeight: "800px",
    background: "linear-gradient(-45deg, #114ebd, #0f3d6e)",
    position: "relative",
    "@media only screen and (max-width: 820px)": {
      position: "absolute",
      background: "none",
      width: "96%",
      padding: "30px 2%",
    },
    "@media only screen and (max-width: 768px)": {
      position: "absolute",
      background: "none",
      width: "96%",
      padding: "30px 2%",
    },
    "& ul": {
      listStyle: "none",
      margin: "0px",
      padding: "0px",
      "& li": {
        color: "#1C295D",
        fontSize: "12px",
        fontWeight: "500",
      },
      "& li button": {
        background: "#f1f1f1",
        width: "150px",
        height: "55px",
        margin: "8px 0",
        textAlign: "center",
        color: "#0f3d6e",
        borderRadius: "10px",
        fontSize: "18px",
        "&:hover": {
          background: "#0f3d6e",
        },
      },
    },
  },
  leftnav: {
    position: "absolute",
    top: "15px",
    bottom: "15px",
    left: "40px",
    right: "40px",
    "@media only screen and (max-width: 1200px)": {
      left: "20px",
      right: "20px",
    },
  },
  topheading: {
    fontSize: "18px",
    color: "#000",
    fontWeight: "500",
    alignSelf: "flex-start",
  },
  PatientListTable: {
    width: "100%",
    "@media only screen and (min-device-width: 768px) and (max-device-width: 1200px)":
      {
        overflowX: "auto",
      },
  },
  throw: {
    display: "flex",
    justifyContent: "space-between",
    borderBottom: "2px #E3E5E5 solid",
    fontSize: "14px",
    color: "#fff",
    paddingBottom: "5px",
    background: "linear-gradient(to left, #114ebd, #0f3d6e)",
    padding: 6,
    "@media only screen and (min-device-width: 768px) and (max-device-width: 1200px)":
      {
        width: 1366,
      },
  },
  tdrow: {
    display: "flex",
    justifyContent: "space-between",
    borderBottom: "1px #E3E5E5 solid",
    fontSize: "14px",
    padding: "10px 0",
    "@media only screen and (min-device-width: 768px) and (max-device-width: 1200px)":
      {
        width: 1366,
      },
  },
  providerbtn: {
    display: "flex",
    cursor: "pointer",
    "& span": {
      display: "flex",
      flexDirection: "column",
      width: "20px",
      marginRight: "10px",
      "& button": {
        background: "none",
        border: "none",
        height: "10px",
        cursor: "pointer",
      },
    },
  },
  provider: {
    width: "15%",
    textAlign: "canter",
  },
  time: {
    width: "15%",
    textAlign: "center",
  },
  phone: {
    width: "15%",
    textAlign: "center",
    wordWrap: "break-word",
    overflow: "auto",
  },
  hrpm: {
    width: "10%",
    textAlign: "center",
    wordWrap: "break-word",
    overflow: "auto",
  },
  program: {
    width: "15%",
    textAlign: "left",
    cursor: "pointer",
  },
  date: {
    width: "10%",
    textAlign: "center",
  },
  reason: {
    width: "10%",
    textAlign: "center",
    cursor: "pointer",
  },
  action: {
    width: "10%",
    textAlign: "center",
    cursor: "pointer",
  },
  ccmmodal: {
    borderRadius: "10px",
    minWidth: "300px",
    padding: "20px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
  },
  Modalclose: {
    width: 45,
    height: 45,
    minWidth: 45,
    borderRadius: 50,
    position: "absolute",
    right: 12,
    top: 10,
  },
  closebtn: {
    width: "40px",
    position: "absolute",
    right: "10px",
    height: "40px",
    background: "#fff",
    top: "10px",
    minWidth: "40px",
    "&:hover": {
      background: "#fff",
    },
  },
  closeicon: {
    fontSize: "25px",
    color: "#7087A7",
  },
  Deletebtn: {
    background: "#fff",
    border: "1px #114ebd solid",
    width: "60px",
    height: "30px",
    float: "right",
    color: "#114ebd",
    textTransform: "capitalize",
    borderRadius: "10px",
    fontWeight: "600",
    marginBottom: "10px",
    marginRight: "10px",
    "&:hover": {
      background: "#114ebd",
      color: "#fff",
    },
  },
  radioGroup: {
    display: "flex",
    flexWrap: "wrap",
    gap: "10px",
    marginTop: theme.spacing(2),
    overflowX: "auto",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  radioOption: {
    // flexShrink: 0,
    width: "100px",
    minWidth: "100px",
    padding: theme.spacing(1),
    borderRadius: theme.shape.borderRadius,
    textAlign: "center",
    background: "#23148B",
    color: "#fff",
    fontSize: "0.875rem",
    fontWeight: 300,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    "&.checked": {
      background: "#1d47bd",
    },
  },
  modal: {
    "& .MuiPaper-rounded": {
      borderRadius: "10px !important",
      padding: "20px",
      width: "500px",
      maxWidth: "776px",
      height: "200px",
    },
    "& .MuiFormControlLabel-label": {
      flex: "0 0 220px !important",
    },
    "& .MuiTypography-root": {
      fontSize: 14,
      fontFamily: "poppins",
    },
    "& .MuiBox-root": {
      width: "100%",
    },
  },
  chartbtn: {
    background: "#0f3d6e",
    borderRadius: "10px",
    padding: "0 20px",
    height: "40px",
    color: "#fff",
    textTransform: "capitalize",
    fontSize: "14px",
    cursor: "pointer",
    "&:hover": {
      background: "#333",
    },
  },
}));
